import axios from '@axios' //eslint-disable-line

export default {
    me() {
        return axios.get('/auth/me')
    },
    logout() {
        return axios.post('/auth/logout')
    },
    getUsersToImpersonate() {
        return axios.get('/auth/impersonate/users')
    },
    impersonateUser(uuid) {
        return axios.post('/auth/impersonate', {
            user_uuid: uuid,
        })
    },
    returnToOriginalUser() {
        return axios.post('/auth/impersonate/logout')
    },
}
